import { render, staticRenderFns } from "./newresto.vue?vue&type=template&id=10ec755e&scoped=true"
import script from "./newresto.vue?vue&type=script&lang=js"
export * from "./newresto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ec755e",
  null
  
)

export default component.exports